module.exports = __webpack_public_path__ + "img/mp-crud.1165dc90.gif";